import React from 'react';

interface ExclusiveContentMenuProps {
  page: string;
  setPage: React.Dispatch<React.SetStateAction<string>>;
}

const ExclusiveContentMenu = (props: ExclusiveContentMenuProps) => {
  const { page, setPage } = props;

  return (
    <ul className="list-group">
      <h5 className="list-group-item mb-0 font-weight-bold">Conteúdo Exclusivo</h5>
      <button
        type="button"
        className={`list-group-item text-left ${page === 'bolsa_de_empregos' ? 'active' : ''} `}
        onClick={() => setPage('bolsa_de_empregos')}
      >
        Bolsa de Empregos
      </button>
      <button
        type="button"
        className={`list-group-item text-left ${
          page === 'clipping_policia_federal' ? 'active' : ''
        } `}
        onClick={() => setPage('clipping_policia_federal')}
      >
        Clipping Polícia Federal
      </button>
    </ul>
  );
};

export default ExclusiveContentMenu;
